/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'Brak wzmianek'
  },
  SENTENCE: {
    INSTAGRAM_LINK:
      'Wspomniałeś o Prozisie na Instagramie tego dnia {publishedAt}',
    NO_ROWS_MENTIONS: 'Nie wspomniałeś jeszcze o prozis na swoim Instagramie'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
